// Excluding and reinstating a Gmail thread the sweep filed onto a project.
import { useMutation, useQueryClient } from "react-query";
import { QK, queryKeys } from "../queryKeys";

import { useAgentsHttp } from "../useAgentsHttp";
import { retryOn5xx } from "./useDriveSync";

interface ThreadActionResponse {
  project_id: string;
  thread_id: string;
}

interface ThreadActionInput {
  project_id: string;
  thread_id: string;
}

const useThreadAction = (path: string) => {
  const http = useAgentsHttp();
  const queryClient = useQueryClient();
  return useMutation<ThreadActionResponse, Error, ThreadActionInput>(
    // Retry a transient 5xx (a Lambda-concurrency 503 during an extraction storm);
    // a 4xx rethrows immediately and the caller surfaces it.
    (body) => retryOn5xx<ThreadActionResponse>(http, path, body),
    {
      onSuccess: (_resp, vars) => {
        queryClient.invalidateQueries([QK.uploadsTree, vars.project_id]);
        queryClient.invalidateQueries(queryKeys.projectGet(vars.project_id));
      },
    },
  );
};

export const useExcludeGmailThread = () => useThreadAction("/projects/gmail/exclude-thread");

// Reactivates the row, clears dismissed_at and re-merges its cached facts (BE), so
// the thread rejoins the active list and leaves the Excluded section.
export const useReinstateGmailThread = () =>
  useThreadAction("/projects/gmail/reinstate-thread");
